<template>
  <div class="progress-bar">
    <progress
      max="100"
      :value="progress"
    />
    <p class="progress-bar-text">
      {{ progress }}%
    </p>
  </div>
</template>
<script setup lang="ts">
interface Props {
    progress: number;
}
defineProps<Props>();
</script>

<style scoped>
  .progress-bar {
    @apply flex items-center w-full;
  }
  .progress-bar-text {
    @apply ml-4 font-bold;
  }

  .progress-bar progress {
    @apply
      bg-white
      w-full
      h-2
      rounded-xl;
  }

  .progress-bar progress::-webkit-progress-bar {
    @apply bg-white rounded-xl;
  }

  .progress-bar progress::-webkit-progress-value {
    @apply bg-accent-300 rounded-xl;
  }

  .progress-bar progress::-moz-progress-bar {
    @apply bg-accent-300 rounded-xl;
  }
</style>
